import * as React from 'react';
import type { OnlineSemesterItem } from '../../Semester/OnlineSemesterItem.csharp';
import type { ParentStudyViewModel } from '../../Semester/ParentStudyViewModel';
import type { OnlineStudySubject } from '../../ViewModel/Subjects/OnlineStudySubject.csharp';
import { OnlineStudyPlanContext } from '../Context/OnlineStudyPlanContext';
import type { SubjectsTabsTabProps } from '../Tabs/SubjectsTabs';
import { Txt } from '../Txt';
import type { OnlineSemesterViewModel } from './Semester/Semester';
import { Semester } from './Semester/Semester';
import styles from './SubjectsBySemester.module.css';

export interface SubjectsBySemesterProps extends SubjectsTabsTabProps {
    parentStudy: ParentStudyViewModel;
    semesters: OnlineSemesterViewModel[];
}

export interface OnlineSemesterItemViewModel extends OnlineSemesterItem {
    index: number;
    selectedElectiveSubjects: OnlineStudySubject[];
    hasOpenedAvailableElectiveSubjects: boolean;
}

export const SubjectsBySemester: React.FC<React.PropsWithChildren<SubjectsBySemesterProps>> = ({
    parentStudy,
    semesters,
}) => {
    const { currentTab, getHoursPerWeekFromTimeType } = React.useContext(OnlineStudyPlanContext);

    return (
        <div className={styles.SubjectsBySemester}>
            <p className={styles.Heading}>
                <Txt
                    id="hoursPerWeek"
                    values={{
                        studyFormType: currentTab.toString().toLowerCase(),
                        hours: getHoursPerWeekFromTimeType(parentStudy.timeType),
                    }}
                />
            </p>
            <ul className={styles.SemesterList}>
                {semesters.map(semester => (
                    <Semester key={`${semester.index}`} semesterInitial={semester} parentStudy={parentStudy} />
                ))}
            </ul>
        </div>
    );
};
